const SetStoreMapper = require('../shoplocator/atm/set-store-mapper');

module.exports = function (shopLocatorService, storePickerService, helpService, storePickerPanelService, atm, deliveryService, currentUserService, shopperService, $state, bwsNotificationService, settingsService) {
    return {
        strict: 'E',
        transclude: true,
        scope: {},
        link(scope) {
            scope.storePicker = storePickerService;
            scope.storePickerPanelService = storePickerPanelService;
            scope.user = currentUserService.currentUser;
            scope.setSelectedValue = { mode: true };
            storePickerPanelService.changeStoreView = true;
            scope.helpService = helpService;
            scope.showSuccessMessage = false;
            scope.hasStore = false;
            scope.isNotifyMe = false;
            scope.userDetails = {
                firstName: scope.user.isGuest ? null : scope.user.firstName,
                lastName: '',
                email: scope.user.isGuest ? null : scope.user.email
            };

            settingsService.getSettingValue('MobileApp', 'EnableDeliveryGuaranteeFeature').then((value) => {
                scope.deliveryGuaranteeNewMessageFeatureFlag = value || false;
            });

            scope.firstAvailableTime = '';

            function displayDeliveryTime(dto) {
                helpService.getDeliveryWindowTime(dto).then(() => {
                    if (helpService.hideAsapTimeOption) {
                        const dateToday = new Date();
                        const dateTomorrow = new Date();
                        dateTomorrow.setDate(dateToday.getDate() + 1);

                        scope.nextWindowDateTimeText = null;
                        scope.nextWindowDayTimeText = null;

                        if (helpService.deliveryTimeTable.length) {

                            const nextDeliveryDate = new Date(helpService.deliveryTimeTable[0].WindowDate).getDate();

                            scope.firstAvailableTime = {
                                windowTime: helpService.deliveryTimeTable[0].WindowTimings[0],
                                windowRange: helpService.deliveryTimeTable[0].WindowRanges[0]
                            };
                            if (nextDeliveryDate === dateToday.getDate()) {
                                scope.nextWindowDateTimeText = 'today';
                            } else if (nextDeliveryDate === dateTomorrow.getDate()) {
                                scope.nextWindowDateTimeText = 'tomorrow';
                            } else {
                                scope.nextWindowDayTimeText = helpService.deliveryTimeTable[0].WindowDate;
                            }
                        }
                    }
                });
            }

            scope.searchStores = () => {
                scope.isNotifyMe = false;
                scope.loading = true;
                scope.isProcessing = true;
                scope.isSearchingStores = true;
                scope.showSuccessMessage = false;

                shopLocatorService.listSupermarkets({
                    Max: 15,
                    Latitude: scope.storePicker.store.Latitude,
                    Longitude: scope.storePicker.store.Longitude
                }).then(function (response) {
                    scope.storesList = response.DeliveryStores;
                    scope.loading = false;
                    scope.isSearchingStores = false;
                    scope.hasStore = false;
                    scope.isProcessing = false;

                    const apiBody = {
                        Postcode: storePickerPanelService.deliverySearch.PostCode,
                        Suburb: storePickerPanelService.deliverySearch.SuburbName,
                        State: storePickerPanelService.deliverySearch.State
                    };

                    displayDeliveryTime(apiBody);
                });
            };

            /**
             * Build the notification DTO. Changes based upon whether the user is logged in
             * and updates with each search
             * @returns {{NotifiedReason: string, Postcode, Suburb: (*|string|string|number), State, FirstName: null, LastName: null, Email: null}}
             */
            function buildNotificationRequest() {
                return {
                    NotifiedReason: 'Enable Delivery',
                    Postcode: storePickerPanelService.deliverySearch.PostCode,
                    Suburb: storePickerPanelService.deliverySearch.SuburbName,
                    State: storePickerPanelService.deliverySearch.State,
                    FirstName: scope.userDetails.firstName,
                    LastName: '',
                    Email: scope.userDetails.email
                };
            }

            scope.notifyDelivery = function (form) {

                if (!form.$valid) {
                    return false;
                }

                scope.isProcessing = true;
                const dto = buildNotificationRequest();
                shopperService.setNotification(dto).then(() => {
                    scope.isProcessing = false;
                    scope.isNotifyMe = true;
                });
            };
            scope.setSelectedStore = function () {
                scope.loading = true;
                scope.hasStore = true;

                scope.storePicker.setDeliveryByStoreNo(scope.storesList[0].StoreNo).then(function () {
                    const fulfilmentInfo = scope.storePicker.fulfilmentInfo;

                    scope.storePicker.store.SuburbName = fulfilmentInfo.DeliveryDetails.FulfilmentStoreID;

                    const atmData = {
                        event: 'BWSAUupdateStorePreferenceHelpDeliveryPage',
                        store: {
                            StoreNo: fulfilmentInfo.DeliveryDetails.FulfilmentStoreID,
                            Postcode: fulfilmentInfo.DeliveryDetails.StoreAddressPostalCode,
                            Name: fulfilmentInfo.DeliveryDetails.FulfilmentStoreName
                        },
                        fulfilmentInfo
                    };

                    atm.push(atmData, SetStoreMapper);

                    scope.storeLocation = storePickerPanelService.deliverySearch;

                    storePickerPanelService.setSuburbInLocalStorage(storePickerPanelService.deliverySearch);
                    bwsNotificationService.success(`Delivery to <strong>${storePickerPanelService.deliverySearch.SuburbName}</strong> has been set.`);
                }).finally(function () {
                    scope.showSuccessMessage = true;
                    scope.loading = false;
                    deliveryService.getDeliveryWindows();
                });
            };

        },
        template: require('./delivery-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help/delivery-directive.js
 **/